/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ServerObject } from '../../models/server-object';
import { ServerObjectInstance } from '../../models/server-object-instance';
import { ServerObjectService } from '../../services/server-object.service';

declare var $: any;

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  licensingServerObjectInstance: ServerObjectInstance;
  serverObjectInstanceId: number;
  emailAccount = null;
  passwordPolicy = null;
  session = null;
  userLockout = null;
  licensingEmail = null;
  licensingDays = null;
  mapping = null;
  settingsDefaultService = {};
  components = [];

  constructor(private serverObjectService: ServerObjectService) {
  }


  ngOnInit(): void {

    this.serverObjectService.getAllServerObjects().then(
      response => {
        for (const object of response) {
          if (object.name == "Edgefinity Server") {
            this.serverObjectService.getAllServerObjectInstances().then(
              responseAllServerObjects => {
                for (const objectInstance of responseAllServerObjects) {
                  if (objectInstance.serverObject && objectInstance.serverObject.id == object.id) {
                    const serverObjectInstance = objectInstance;
                    this.serverObjectInstanceId = serverObjectInstance.id;
                    console.log("Found Edgefinity Server Instance ID as " + this.serverObjectInstanceId);

                    for(const dataElement of serverObjectInstance.data) {
                      if (dataElement.property && dataElement.property.property) {
                        if (dataElement.value) {
                          console.log("Got value of " + dataElement.property.property);
                          if (dataElement.object_value.server_object_reference) {
                            this.settingsDefaultService[dataElement.property.property] = dataElement.object_value.server_object_reference;
                          } else if (dataElement.object_value.service_reference) {
                            this.settingsDefaultService[dataElement.property.property] = dataElement.object_value.service_reference;
                          } else {
                            this.settingsDefaultService[dataElement.property.property] = dataElement.object_value;
                          }
                        }
                      }
                    }

                    break;
                  }
                }

                this.emailAccount = this.settingsDefaultService['email_account'];
                this.passwordPolicy = this.settingsDefaultService['password_policy'];
                this.session = this.settingsDefaultService['session'];
                this.userLockout = this.settingsDefaultService['user_lockout'];
                this.licensingEmail = this.settingsDefaultService['licensing_email_addresses'];
                this.licensingDays = this.settingsDefaultService['licensing_expire_num_days'];
                this.mapping = this.settingsDefaultService['mapping'];
                this.serverObjectService.getServerObjectInstanceById(this.serverObjectInstanceId).then(
                  serverObjectInstanceResponse => {
                              this.licensingServerObjectInstance = serverObjectInstanceResponse;
                        },
                  error => {
                    console.error("Could not find the Edgefinity Server Object Instance" + this.serverObjectInstanceId);
                  }

                );
              },
              error => {
                console.error("Could not find the Edgefinity Server Instance");
              }
            );
            break;
          }
        }
      },
      error => {
        console.error("Could not find the Edgefinity Server Object");
      }
    )


  }

  defaultServersFound(): void {

  }

  //getServerObjectInstance(): ServerObjectInstance {
  //  return this.serverObjectInstance;
  //}

  hideAllSettings(): void {
    $("#settingsEmail").hide();
    $("#settingsPasswordPolicy").hide();
    $("#settingsSession").hide();
    $("#settingsUserLockout").hide();
    $("#settingsLicensing").hide();
    $("#settingsLocate").hide();
  }

  showEmail(): void {
    this.hideAllSettings();
    $("#settingsEmail").show();
  }

  showPassword(): void {
    this.hideAllSettings();
    $("#settingsPasswordPolicy").show();
  }

  showSession(): void {
    this.hideAllSettings();
    $("#settingsSession").show();
  }

  showUser(): void {
    this.hideAllSettings();
    $("#settingsUserLockout").show();
  }

  showLicensing(): void {
    this.hideAllSettings();
    $("#settingsLicensing").show();
  }

  showLocate(): void {
    this.hideAllSettings();
    $("#settingsLocate").show();
  }

}
